import { backend } from 'modules/data';
import { useMemo } from 'react';
import { useGetFields } from 'shared/data/webApp/v1';

export const useGetTrackingFields = (companyId: string) => {
    const { data, ...params } = useGetFields({
        query: {
            companyId,
            withValues: true,
            allFields: true,
        },
    });

    const trackingFieldsData = useMemo(() => {
        return data?.fields.filter(({ systemPurpose }) => systemPurpose === backend.FieldSystemPurpose.XeroTracking);
    }, [data?.fields]);

    return { ...params, data: trackingFieldsData };
};
